import { createI18n } from 'vue-i18n'
import fr from './locales/fr-FR.json'
import en from './locales/en.json'
import enUS from './locales/en-US.json'


export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: localStorage.getItem("locale") || "fr-FR", // default locale can be overridden by user selection
  fallbackLocale: "fr-FR", // used when key missing from selected locale
  messages: {
    "fr": fr,
    "fr-FR": fr,
    "en": en,
    "en-US": enUS,
  }
})
